const findEle = (parent, type) => {
  return parent.tagName.toLowerCase() === type ? parent : parent.querySelector(type)
}
const trigger = (el, type) => {  // 给元素绑定事件
  const e = document.createEvent('HTMLEvents')
  e.initEvent(type, true, true)
  el.dispatchEvent(e)
}

const isEmojiCharacter = (substring) => {
  for (let i = 0; i < substring.length; i++) {
    let hs = substring.charCodeAt(i)
    if (hs >= 0xd800 && hs <= 0xdbff) {
      if (substring.length > 1) {
        let ls = substring.charCodeAt(i + 1)
        let uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000
        if (uc >= 0x1d000 && uc <= 0x1f77f) {
          return true
        }
      }
    } else if (substring.length > 1) {
      let ls = substring.charCodeAt(i + 1)
      if (ls === 0x20e3) {
        return true
      }
    } else {
      if (hs >= 0x2100 && hs <= 0x27ff) {
        return true
      } else if (hs >= 0x2B05 && hs <= 0x2b07) {
        return true
      } else if (hs >= 0x2934 && hs <= 0x2935) {
        return true
      } else if (hs >= 0x3297 && hs <= 0x3299) {
        return true
      } else if (hs === 0xa9 || hs === 0xae || hs === 0x303d || hs === 0x3030 ||
        hs === 0x2b55 || hs === 0x2b1c || hs === 0x2b1b ||
        hs === 0x2b50) {
        return true
      }
    }
  }
  return false
}
const emoji = {
  bind: function (el, binding, vnode) { // 添加监听事件
    console.log(el, 'el')
    // 判断是否是emoji图标
    const isEmoji = char => {
      // 表情都是2个字符
      return char.length > 1
    }
    const emoji2empty = str => {  // emoji图标都替换成空字符串‘’
      return Array.from(str)
        .filter(c => !isEmoji(c)).join('')
    }
    let $inp = findEle(el, 'input') || findEle(el, 'textarea')  // 判断绑定元素是否是input输入框或者富文本输入框
    el.$inp = $inp
    $inp.handle = function () {
      let val = $inp.value
      if (!isEmojiCharacter(val)) {
        return
      }
      $inp.value = emoji2empty(val)  // 监听输入框的emoji图标转换成空
      trigger($inp, 'input')
    }
    $inp.addEventListener('keyup', $inp.handle)  // el添加键盘监听事件keyup
    $inp.addEventListener('blur', $inp.handle) // el添加键盘失焦事件blur
  },
  unbind: function (el) {  // 取消监听事件
    el.$inp.removeEventListener('keyup', el.$inp.handle)
    el.$inp.removeEventListener('blur', el.$inp.handle)
  }
}
export default emoji



// WEBPACK FOOTER //
// ./src/assets/js/emoji.js